import React, { SyntheticEvent, useEffect, useState } from 'react';
import AutocompleteProperties from "./AutocompleteProperties";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";
import { AutocompleteChangeReason, AutocompleteInputChangeReason } from "@mui/material";

const AutocompleteItem: React.FC<AutocompleteProperties> = ({
    onChangeValue,
    onChangeInput,
    itemName,
    elements,
    label,
    fullWidth = false,
    className = '',
}: AutocompleteProperties) => {

    const [inputValue, setInputValue] = useState(itemName || "");
    const [debounceTimeout, setDebounceTimeout] = useState<NodeJS.Timeout | null>(null);

    // Atualiza inputValue sempre que o prop mudar
    useEffect(() => {
        setInputValue((itemName || "").toUpperCase());
    }, [itemName]);

    // Debounced onChangeInput
    const handleInputChange = (event: SyntheticEvent<Element, Event>, value: string, reason: AutocompleteInputChangeReason) => {
        const upperValue = value.toUpperCase();
        setInputValue(upperValue);

        if (debounceTimeout) clearTimeout(debounceTimeout);

        const timeout = setTimeout(() => {
            onChangeInput(upperValue);
        }, 800);

        setDebounceTimeout(timeout);
    };

    const handleValueChange = (
        event: SyntheticEvent<Element, Event>,
        value: string | { id: string; label: string } | null,
        reason: AutocompleteChangeReason
    ) => {
        if (value != null) {
            onChangeValue((value as { id: string; label: string }).id);
        }
    };

    return (
        <Autocomplete
            fullWidth={fullWidth}
            className={className}
            inputValue={inputValue}
            onInputChange={handleInputChange}
            onChange={handleValueChange}
            freeSolo
            options={elements.map(option => ({ id: option.value, label: option.primaryText }))}
            renderInput={(params) => <TextField {...params} label={label} />}
        />
    );
};

export default AutocompleteItem;
